import { MAX_NUMBER_OF_CHILDREN, MIN_NUMBER_OF_CHILDREN } from '@shared/sec-loans'
import { validateIntegerFromListOrOther } from '@ui-common/utils'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, only, Suite, test } from 'vest'

import { IfpHouseholdInfoFormData as FormData } from './types'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: FormData, changedFields?: FieldName<FormData>[]) => void> => {
  return create((data, changedFields) => {
    only(changedFields)

    test('numberOfAdults', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.numberOfAdults).isBetween(1, 2)
    })

    validateIntegerFromListOrOther(
      'numberOfChildren',
      formatMessage,
      data.numberOfChildren,
      data.numberOfChildrenOther,
      MIN_NUMBER_OF_CHILDREN,
      MAX_NUMBER_OF_CHILDREN,
    )
  })
}
